import React, { FC } from "react";
import { ObjectName, ObjectPreview } from "react-inspector";

type MessageDirection = "up" | "down";

export const ObjectRootLabel: FC<{
  name?: string;
  data: any;
  direction?: MessageDirection;
}> = ({ name, data, direction }) => {
  if (typeof name === "string") {
    return (
      <span>
        <ObjectName name={name} />
        <span>: </span>
        <ObjectPreview data={data} />
      </span>
    );
  }
  if (direction === "up" || direction === "down") {
    const arrow = direction === "up" ? "↑" : "↓";

    return (
      <span>
        <span
          style={{
            background:
              direction === "up" ? "rgba(0,255,0,0.2)" : "rgba(255,0,0,0.2)",
            // color: "white",
            width: 12,
            height: 12,
            borderRadius: 2,
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: 4,
            lineHeight: "12px",
          }}
        >
          {arrow}
        </span>
        <ObjectPreview data={data} />
      </span>
    );
  } else {
    return <ObjectPreview data={data} />;
  }
};
